const env = process.env.NODE_ENV || 'development'
const cdnServer = 'https://cdn.svc.oneadvanced.com'

const dsMap = {
  development: {
    component: '../../tmp',
    icon: '../../node_modules/@advanced/mosaic-icons',
    vendor: '../../node_modules',
    theme: '../../tmp'
  },
  production: {
    component: `${cdnServer}/mosaic-components/latest`,
    icon: `${cdnServer}/mosaic-icons`,
    vendor: `${cdnServer}/mosaic-components/latest/vendor`,
    theme: `${cdnServer}/mosaic-components/latest`
  }
}

/**
 * Function to return the full path of the component resource
 * @function getComponentPath
 * @param {string} path The component resource
 * @returns {string} The full path to the component resource
 */
export const getComponentPath = (path) => {
  if (window.mosaic.config && window.mosaic.config.componentPath) {
    return `${window.mosaic.config.componentPath}${path}`
  }
  return `${dsMap[env].component}${path}`
}

/**
 * Function to return the full path of the icon resource
 * @function getIconPath
 * @param {string} path The icon resource
 * @returns {string} The full path to the icon resource
 */
export const getIconPath = (path) => {
  if (window.mosaic.config.iconPath) {
    return `${window.mosaic.config.iconPath}${path}`
  }
  return `${dsMap[env].icon}${path}`
}

/**
 * Function to return the full path of the vendor resource
 * @function getVendorPath
 * @param {string} path The vendor resource
 * @returns {string} The full path to the vendor resource
 */
export const getVendorPath = (path) => {
  if (window.mosaic.config.vendorPath) {
    return `${window.mosaic.config.vendorPath}${path}`
  }
  return `${dsMap[env].vendor}${path}`
}

/**
 * Function to return the full path of the theme resource
 * @function getThemePath
 * @param {string} path The theme resource
 * @returns {string} The full path to the theme resource
 */
export const getThemePath = (path) => {
  if (window.mosaic.config.themePath) {
    return `${window.mosaic.config.themePath}${path}`
  }
  return `${dsMap[env].theme}${path}`
}

/**
 * Function to return an object of startup configuration
 * @returns {object}
 */
export function getConfig () {
  let config = {
    componentPath: null,
    iconPath: null,
    vendorPath: null,
    themePath: null,
    componentBundle: null,
    extensionsPath: null,
    frameworkBundle: null,
    useLayout: false,
    useControls: false,
    useData: false,
    useForms: false,
    useMessaging: false,
    usePages: false,
    usePageLoader: false
  }

  // config for internal tools like storybook and codepen
  config.isStorybook = false
  config.useTools = false

  if (window.mosaicConfigure) {
    config = typeof window.mosaicConfigure === 'function'
      ? { ...config, ...window.mosaicConfigure() }
      : { ...config, ...window.mosaicConfigure }
  }

  if (!config.componentPath) config.componentPath = dsMap[env].component
  if (!config.vendorPath) config.vendorPath = dsMap[env].vendor
  if (!config.iconPath) config.iconPath = dsMap[env].icon
  if (!config.themePath) config.themePath = dsMap[env].theme

  return config
}
